<ng-container *transloco="let t; read: 'profile-list-location-filter'">
  <div class="filter-section">
    <accredible-search-input labelKey="description"
      [label]="t('location')"
      [hint]="t('filter_by_city')"
      [formControlRef]="locationFormControl"
      [dynamic]="true"
      [options]="locationSearchPredictions()"
      [placeholder]="t('city_name')"
      [loading]="isLoading()"
      (search)="onSearchLocations($event)"
      (clear)="onRemoveLocation()"
      (select)="onSelectOption($event)"/>

    <accredible-checkbox-input size="large"
      [formControlRef]="radiusDistanceFormControl"
      (change)="onRadiusDistanceToggle()">
      {{ t('radius_distance') }}
    </accredible-checkbox-input>

    @if (radiusDistanceFormControl.value) {
      <accredible-radio-input [formControlRef]="radiusMetricFormControl"
        [label]="t('unit')"
        [options]="radiusMetricOptions"/>

      <mat-slider #slider
        step="5"
        aria-label="units"
        [min]="MIN_RADIUS_DISTANCE"
        [max]="radiusMetricFormControl.value === distanceMetric.MILES ? MAX_RADIUS_DISTANCE_MI : MAX_RADIUS_DISTANCE_KM"
        [(ngModel)]="radiusValue"
        (change)="onRadiusChange()"/>
      <div class="metrics-min-max">
        <label>
          {{ radiusMetricFormControl.value === distanceMetric.MILES ? MIN_RADIUS_DISTANCE_MI_TEXT : MIN_RADIUS_DISTANCE_KM_TEXT }}
        </label>
        <label>
          {{ radiusMetricFormControl.value === distanceMetric.MILES ? MAX_RADIUS_DISTANCE_MI_TEXT : MAX_RADIUS_DISTANCE_KM_TEXT }}
        </label>
      </div>
      <div class="selected-range"
        [innerHTML]="t('selected_range_' + radiusMetricFormControl.value, { value: slider.value })">
      </div>
    }

    <div class="or-country-state">
      <div class="label-clear">
        <span>{{ t('or_country_state') }}</span>

        @if (countryFormControl.value !== selectCountryTranslation) {
          <button mat-stroked-button
            class="mat-default mat-button-small"
            (click)="clearCountryState()">
            {{ t('clear') }}
          </button>
        }
      </div>

      <accredible-select-input class="country-select"
        [formControlRef]="countryFormControl"
        [noErrorMargin]="true"
        [options]="countryOptions()"/>

      <accredible-select-input [formControlRef]="stateFormControl"
        [noErrorMargin]="true"
        [options]="stateOptions()"/>
    </div>
  </div>
</ng-container>
